/*
 * @Author: Daokai Huo
 * @Date: 2021-10-21 16:15:04
 * @LastEditTime: 2021-10-21 16:17:27
 * @Description:
 */
import IonSearch from './src/ion-search.vue';

IonSearch.install = function install(_vue) {
  _vue.component(IonSearch.name, IonSearch);
};
export default IonSearch;
